import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <h4 className="footer-note">2023 - Movie List App</h4>
    </div>
  );
};

export default Footer;
